module.exports = __webpack_public_path__ + "img/beach.b3829ef9.svg";